/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Art_NoteInputs */

const en_svc_research_art_note = /** @type {(inputs: Svc_Research_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative brief. Your criteria decide what counts as a fit.`)
};

const lv_svc_research_art_note = /** @type {(inputs: Svc_Research_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustratīvs kopsavilkums. Atbilstību nosaka Jūsu kritēriji.`)
};

/**
* | output |
* | --- |
* | "Illustrative brief. Your criteria decide what counts as a fit." |
*
* @param {Svc_Research_Art_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_art_note = /** @type {((inputs?: Svc_Research_Art_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Art_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_art_note(inputs)
	return en_svc_research_art_note(inputs)
});